/**
 * @file tooltip.tsx
 * @description Tooltip-примитив на base-ui (phase08.5).
 */

import { Tooltip as TooltipPrimitive } from "@base-ui/react/tooltip";
import * as React from "react";

import { cn } from "@/lib/utils";

const TooltipProvider = TooltipPrimitive.Provider;
const Tooltip = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;

interface TooltipContentProps
  extends React.ComponentProps<typeof TooltipPrimitive.Popup> {
  sideOffset?: number;
}

function TooltipContent({
  className,
  sideOffset = 6,
  children,
  ...props
}: TooltipContentProps) {
  return (
    <TooltipPrimitive.Portal>
      {/* z-index — на позиционере: попап `position: static` (см. popover.tsx). */}
      <TooltipPrimitive.Positioner
        sideOffset={sideOffset}
        className="z-[var(--z-popover)]"
      >
        <TooltipPrimitive.Popup
          data-slot="tooltip-content"
          className={cn(
            "rounded-md bg-on-surface text-on-primary px-2 py-1 text-xs",
            "[box-shadow:0_4px_12px_var(--shadow-tooltip)]",
            "data-[ending-style]:opacity-0 data-[starting-style]:opacity-0",
            "transition-opacity duration-150",
            className,
          )}
          {...props}
        >
          {children}
        </TooltipPrimitive.Popup>
      </TooltipPrimitive.Positioner>
    </TooltipPrimitive.Portal>
  );
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
